export const handlePhoneKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (
    !/[0-9]/.test(e.key) &&
    e.key !== 'Backspace' &&
    e.key !== 'ArrowLeft' &&
    e.key !== 'ArrowRight' &&
    e.key !== 'Tab'
  ) {
    e.preventDefault()
  }
}

export const handlePaymentTermDown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']

  // Allow digits, one dot, and control keys
  if (!/[0-9.]/.test(e.key) && !allowedKeys.includes(e.key)) {
    e.preventDefault()
    return
  }

  const input = e.currentTarget
  const value = input.value

  // Prevent starting with just dot
  if (value === '' && e.key === '.') {
    e.preventDefault()
    return
  }

  // Prevent multiple dots
  if (e.key === '.' && value.includes('.')) {
    e.preventDefault()
    return
  }

  // Prevent more than 2 decimal places
  if (value.includes('.') && e.key !== '.' && !allowedKeys.includes(e.key)) {
    const decimalPart = value.split('.')[1]
    if (decimalPart && decimalPart.length >= 2) {
      e.preventDefault()
    }
  }
}

type InputElement = HTMLInputElement | HTMLTextAreaElement

export const handleTextValidation = (e: React.KeyboardEvent<InputElement>) => {
  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete']

  const isLetterOrSpace = /^[a-zA-Z\s]$/.test(e.key)

  if (!isLetterOrSpace && !allowedKeys.includes(e.key)) {
    e.preventDefault()
    return
  }

  const value = e.currentTarget.value

  if (value.length === 0 && e.key === ' ') {
    e.preventDefault()
    return
  }

  if (value.endsWith(' ') && e.key === ' ') {
    e.preventDefault()
    return
  }
}
interface GetNameValidationRulesProps {
  label: string
  maxLength?: number
  minLength?: number
}

export const getNameValidationRules = ({
  label,
  maxLength,
  minLength,
}: GetNameValidationRulesProps) => {
  return {
    required: `${label} is a required`,
    minLength: {
      value: minLength ?? 2,
      message: `${label} must be at least ${minLength ?? 2} characters`,
    },
    maxLength: {
      value: maxLength ?? 20,
      message: `${label} must not exceed ${maxLength ?? 20} characters`,
    },
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: `${label} must contain only characters`,
    },
  }
}

export const getPhoneValidationRules = (label: string) => {
  return {
    required: `${label} is a required`,
    minLength: {
      value: 10,
      message: `${label} must be at least 10 digits`,
    },
    maxLength: {
      value: 15,
      message: `${label} must not exceed 15 digits`,
    },
    pattern: {
      value: /^[0-9]+$/,
      message: `${label} must contain only digits`,
    },
  }
}

export const formatDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // months are 0-indexed
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
}
